import { DGE_AUTH_METHOD, PLATFORM } from '@/constants/platform'
import { useAuthStore } from '@/stores/useAuthStore'

import { DEFAULT_HEADERS } from './constants/requests'

export const getHeaders = (extraHeaders?: HeadersInit) => {
  const platform = useAuthStore.getState().platform
  const dgeAuthMethod = useAuthStore.getState().dgeAuthMethod
  const token = useAuthStore.getState().token

  const headers = new Headers(extraHeaders)

  for (const [name, value] of Object.entries(DEFAULT_HEADERS)) {
    headers.set(name, value)
  }

  if (token) {
    switch (platform) {
      case PLATFORM.DDE:
        headers.set('Authorization', `Bearer ${token}`)
        break
      case PLATFORM.DGE:
        if (dgeAuthMethod === DGE_AUTH_METHOD.KEYCLOAK) {
          headers.set('Authorization', `Bearer ${token}`)
        } else {
          headers.set('exchange-auth', token)
        }
        break
      default:
        break
    }
  }

  return headers
}
